export default __webpack_public_path__ + "static/media/sponsor2.2de2928b.png";